import { BaseResource } from "./base.resource";

export const UnitAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class Unit extends BaseResource {
  active: boolean;
  name: string;
  abbreviation: string;
  item: boolean;
  container: boolean;
  manifest: boolean;
  unitType: string;
  typeOfItem: string;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & UnitAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & UnitAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & UnitAccessLevel.Delete) > 0;
  }
}
